import React, { useEffect } from "react";
import Wizard from "@semcore/wizard";
import { Flex } from "@semcore/flex-box";
import { Text } from "@semcore/typography";

import AddIcon from "@mui/icons-material/Add";
import SemButton from "../../../../../common/components/Button";
import { handleInvitedUserAccess } from "../../../../../helperJs/helper";
import AddWebsite from "./AddWebsite";
import AddCompetitors from "./AddCompetitors";
import AddKeyword from "./AddKeyword";
import "../.././../../css/addProject.scss";
import { useTranslation } from "react-i18next";

import useUserAccountUsage from "../../../../../helperJs/useUserAccountUsage";
import { AITrackerStore } from "../../../../../store/AITrackerStore";

const steps = ["Website", "Competitors", "Keywords"];
const AddProject = () => {
  const {
    addProject,
    resetAddProject,
    setAddProjectField,
    setMultipleFields,
    userAccessData,
  } = AITrackerStore((state) => state);

  const page_data = userAccessData?.[0]?.access;
  const isPageAccess = handleInvitedUserAccess("addproject", page_data);
  const userAccount = useUserAccountUsage();
  const { t } = useTranslation();

  const handleClose = () => {
    resetAddProject();
  };

  const handleUserClick = () => {
    resetAddProject();
    setAddProjectField("open", true);
  };

  useEffect(() => {
    const projectLimitsEmpty =
      Array.isArray(addProject.project_usage.limits) &&
      addProject.project_usage.limits.length === 0;
    const hasUserUsage =
      userAccount.accUsage && Object.keys(userAccount.accUsage).length !== 0;
    if (projectLimitsEmpty && hasUserUsage) {
      setMultipleFields({
        project_usage: {
          limits: userAccount.accUsage,
          loading: userAccount.loading,
          error: userAccount.error || false,
        },
      });
    }
  }, [addProject.project_usage.limits, userAccount.accUsage]);

  return (
    <>
      <SemButton
        name={t("rank_tracking.map_rank_tracker.add_project_button.title")}
        onClick={handleUserClick}
        title={
          !isPageAccess
            ? "You cannot access this module, Please contact account owner to get access"
            : "Add Project"
        }
        disabled={!isPageAccess}
        icon={<AddIcon />}
      />

      <Wizard
        visible={addProject.open}
        step={addProject.step}
        w={"90%"}
        wMax={"800px"}
        h={"550px"}
        onClose={handleClose}
      >
        <Wizard.Sidebar
          title={t(
            "rank_tracking.map_rank_tracker.add_competitor_modal.sidebar.title"
          )}
          w={"20%"}
        >
          {steps?.map((step, index) => {
            return (
              <Wizard.Stepper
                key={step}
                step={index + 1}
                style={{
                  backgroundColor:
                    addProject.step === index + 1 ? "#FFFFFF" : "#FDA9A8",
                  color: addProject.step === index + 1 ? "#FF8786" : "#FFFFFF",
                  fontWeight: "500",
                }}
                className="mb-1"
              >
                {step}
              </Wizard.Stepper>
            );
          })}
        </Wizard.Sidebar>
        <Wizard.Content tag={Flex} direction="column" w={"80%"} p={4}>
          <Text fontWeight={600} size={500} mb={4}>
            {steps[addProject.step - 1]}
          </Text>
          <Wizard.Step step={1} style={{ overflow: "auto" }}>
            <AddWebsite />
          </Wizard.Step>
          <Wizard.Step step={2} style={{ overflow: "auto" }}>
            <AddCompetitors />
          </Wizard.Step>
          <Wizard.Step step={3} style={{ overflow: "auto" }}>
            <AddKeyword />
          </Wizard.Step>
        </Wizard.Content>
      </Wizard>
    </>
  );
};

export default AddProject;
